import { atom, useAtomValue, useSetAtom } from 'jotai'
import { useCallback } from 'react'

const isOpen = atom(false)
const parentId = atom<string | null | undefined>('')
const isSameOrgOnly = atom(false)

export function useNewWorkspaceModalValues() {
  return {
    isOpen: useAtomValue(isOpen),
    parentId: useAtomValue(parentId),
    isSameOrgOnly: useAtomValue(isSameOrgOnly),
  }
}

export function useShowNewWorkspaceModal() {
  const setIsOpen = useSetAtom(isOpen)
  const setParentId = useSetAtom(parentId)
  const setIsSameOrgOnly = useSetAtom(isSameOrgOnly)

  return useCallback(
    ({
      parentId,
      isSameOrgOnly,
    }: {
      parentId?: string | null
      isSameOrgOnly?: boolean
    }) => {
      setIsOpen(true)
      setParentId(parentId)
      setIsSameOrgOnly(isSameOrgOnly ?? false)
    },
    []
  )
}

export function useCloseNewWorkspaceModal() {
  const setIsOpen = useSetAtom(isOpen)
  const setParentId = useSetAtom(parentId)
  const setIsSameOrgOnly = useSetAtom(isSameOrgOnly)

  return useCallback(() => {
    setIsOpen(false)
    setParentId('')
    setIsSameOrgOnly(false)
  }, [])
}
